console.log('Initializing pub/sub system...');

// Store original values if they exist
const existingPubSubEvents = window.PUB_SUB_EVENTS;
const existingSubscribe = window.subscribe;
const existingPublish = window.publish;

if (existingPubSubEvents || existingSubscribe || existingPublish) {
  console.warn('Pub/sub system already initialized:', {
    events: existingPubSubEvents,
    subscribe: existingSubscribe,
    publish: existingPublish
  });
}

window.PUB_SUB_EVENTS = {
  cartUpdate: 'cart-update'
};

let subscribers = {};

function subscribe(eventName, callback) {
  if (subscribers[eventName] === undefined) {
    subscribers[eventName] = [];
  }

  subscribers[eventName] = [...subscribers[eventName], callback];

  return function unsubscribe() {
    subscribers[eventName] = subscribers[eventName].filter((cb) => {
      return cb !== callback;
    });
  };
}

function publish(eventName, data) {
  if (subscribers[eventName]) {
    subscribers[eventName].forEach((callback) => {
      callback(data);
    });
  }
}

window.subscribe = subscribe;
window.publish = publish;

console.log('Pub/sub system initialized');
